// John Eldhose 20190429
import React, { Component } from 'react';
import { Button, Tab, Tabs, Typography } from '@material-ui/core';
import Loading from './Loading';
import { demoProducts } from '../../Api/demoProducts';

class DemoTab extends Component {

  state = {
    loading: true,
    category: '',
    tab: ''
  }
  products: [];
  componentWillMount() {
    const search = (window.location.search === '') ?
      '' : decodeURI(window.location.search.substring(1));
    demoProducts()
      .then((demo) => {
        if(demo.status === 'true') {
          const cat = (
            search !== '' && typeof demo.data[search] !== 'undefined'
          ) ? search : Object.keys(demo.data)[0];
          const tab = demo.data[cat][0].type;
          this.products = demo.data;
          this.setState({ loading: false, category: cat, tab: tab });
        }
        else
          this.setState({ loading: false });
      })
      .catch((err) => { console.log(err); })
  }
  tabs = {
    Software: {name: 'SOFTWARE', description: <Typography style={{ padding: '20px' }}>Download a free, fully functional trial (good for 30 days for <a href="https://www.carlsonsw.com/stack/office-software" title="Learn more">office software</a>, and up to 15 points for <a href="https://www.carlsonsw.com/stack/data-collection" title="Learn more">data collection software</a>)<br /><a href="https://photocapture.carlsonsw.com/">Demo Carlson PhotoCapture</a> &nbsp; &nbsp; <a href="https://web.carlsonsw.com/files/updates/updates05.php?product=DotSoft">Demo DotSoft</a></Typography>},
    Hardware: {name: 'INSTRUMENTS', description: <Typography style={{ padding: '20px' }}>Contact us for ways to see our <a href="https://www.carlsonsw.com/stack/instruments">instruments</a> and <a href="https://www.carlsonsw.com/stack/machine-control">machine control</a> in action</Typography>}
  };
  getCat0 = (tab) => {
    const keys = Object.keys(this.products);
    for(var i = 0; i < keys.length; i++)
      for(var j = 0; j < this.products[keys[i]].length; j++)
        if(this.products[keys[i]][j].type === tab)
          return keys[i];
  }
  getCats = (tab) => {
    const cats = [];
    const keys = Object.keys(this.products);
    for(var i = 0; i < keys.length; i++)
      for(var j = 0; j < this.products[keys[i]].length; j++)
        if(this.products[keys[i]][j].type === tab) {
          cats.push(keys[i]);
          break;
        }
    return cats;
  }
  getTab = (tab) => {
    return (
      <div>
        <Tabs
          value={tab}
          onChange={
            (e, t) => this.setState({ category: this.getCat0(t), tab: t })
          }
          style={{ backgroundColor: '#eee' }}
        >
          {Object.keys(this.tabs).map(
            (tab) => <Tab key={tab} label={
              <Typography variant='headline'>{this.tabs[tab].name}</Typography>
            } value={tab} />
          )}
        </Tabs>
        {this.tabs[tab].description}
        <Tabs
          value={this.state.category}
          onChange={(e, t) => this.setState({ category: t })}
          scrollable scrollButtons='off'
        >
          {this.getCats(tab).map((cat) => (
              <Tab key={cat} label={
                <Typography variant='subheading'>{cat}</Typography>
              } value={cat} />
          ))}
        </Tabs>
        <p />
        {this.products[this.state.category].map((prod) => {
          return (
            <div key={prod['pname']} style={{ textAlign: 'left' }}>
            <Button
              color='primary'
              onClick={() => this.props.handleDemo(tab, prod)}
            >
              {prod['pname']}
            </Button>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    if(this.state.loading)
      return <Loading />;
    else
      return this.getTab(this.state.tab);
  }
}

export default DemoTab;



// WEBPACK FOOTER //
// ./src/components/lib/DemoTab.js